/* eslint-disable */

export const initKlaviyo = () => {
  window._learnq = window._learnq || [];
  window._learnq.push(['account', 'Hi5VYK']);
  (function () {
    const b = document.createElement('script'); b.type = 'text/javascript'; b.async = true;
    b.src = `${document.location.protocol === 'https:' ? 'https://' : 'http://'}a.klaviyo.com/media/js/analytics/analytics.js`;
    const a = document.getElementsByTagName('script')[0]; a.parentNode.insertBefore(b, a);
  }());
};

/* eslint-enable */
